import { XIcon } from "@heroicons/react/solid";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRecoilState } from "recoil";
import { popupModal } from "../atoms/atom";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";

const Popup = () => {
  const [open, setOpen] = useRecoilState(popupModal);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const SubmitForm = async (e) => {
    e.preventDefault();
    if (!name || !email) {
      toast.error("Please enter complete details");
    } else {
      const payload = { name, email };
      try {
        await axios.post(
          `https://video-editing-api.herokuapp.com/subscribe`,
          payload
        );
        toast.success("Thankyou for subscription");
        setName("");
        setEmail("");
        setOpen(false);
      } catch (error) {
        toast.error(error);
      }
    }
  };

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div>
      {open && (
        <div>
          <div
            data-aos="fade-zoom-in"
            data-aos-delay="200"
            data-aos-duration="1000"
            onClick={() => setOpen(false)}
            className="w-[100%] h-[100vh] transition-all duration-300 ease-out bg-black fixed top-0  bg-opacity-20 right-0 left-0 z-10"
          ></div>
          <div
            data-aos="fade-zoom-in"
            data-aos-delay="200"
            data-aos-duration="1000"
            className="md:max-w-[800px]
           max-w-[420px] scrollbar-hide bg-white  p-4 flex flex-wrap z-50 transition-all duration-300 ease-out items-center overflow-y-scroll lg:scrollbar-hide lg:justify-between justify-around mx-auto fixed top-0 right-0 left-0 bottom-0 lg:max-h-[400px] my-auto"
          >
            <div className="max-w-[370px]">
              <img
                src={require("../images/cameraPoster.jpg")}
                className="w-[100%] h-auto"
                alt=""
              />
            </div>
            <div className="max-w-[375px] ml-2 ">
              <h1 className="my-4 text-[21px] font-bold text-center">
                Struggling to organize ideas for your videos? Then subscribe to
                our email list to get a copy of our free script template!
              </h1>

              <input
                placeholder="Type your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                type="text"
                className="w-[100%] transition-all duration-300 ease-out bg-gray-100 focus:bg-gray-200 outline-none text-[20px] p-3 rounded-sm -none"
              />
              <input
                placeholder="Type your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="text"
                className="w-[100%] my-5 transition-all duration-300 ease-out bg-gray-100 focus:bg-gray-200 outline-none text-[20px] p-3 rounded-sm -none"
              />
              <div className="flex">
                <button
                  onClick={() => setOpen(false)}
                  className="p-3 text-lg font-semibold text-gray-500 transition duration-200 ease-out bg-gray-200 md:px-5 hover:bg-gray-300"
                >
                  No thanks
                </button>
                <button
                  onClick={SubmitForm}
                  className="  p-3  text-lg font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#323a41] md:px-5 text-center mx-auto"
                >
                  Send the template!
                </button>
              </div>

              <div
                onClick={() => setOpen(false)}
                className="absolute p-1 bg-black rounded-full cursor-pointer right-1 top-1"
              >
                <XIcon className="w-5 h-5 font-bold text-white" />
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default Popup;
